import React, { createContext, useContext, useState, useCallback } from "react";

interface ForgotPasswordModalContextValue {
  isForgotPasswordModalOpen: boolean;
  setForgotPasswordModalOpen: (open: boolean) => void;
}

const ForgotPasswordModalContext = createContext<ForgotPasswordModalContextValue | null>(null);

export const useForgotPasswordModal = () => {
  const ctx = useContext(ForgotPasswordModalContext);
  if (!ctx) {
    throw new Error("useForgotPasswordModal must be used within ForgotPasswordModalProvider");
  }
  return ctx;
};

interface ForgotPasswordModalProviderProps {
  children: React.ReactNode;
}

export const ForgotPasswordModalProvider: React.FC<ForgotPasswordModalProviderProps> = ({
  children,
}) => {
  const [isForgotPasswordModalOpen, setForgotPasswordModalOpen] = useState(false);
  const setOpen = useCallback((open: boolean) => setForgotPasswordModalOpen(open), []);
  return (
    <ForgotPasswordModalContext.Provider
      value={{ isForgotPasswordModalOpen, setForgotPasswordModalOpen: setOpen }}
    >
      {children}
    </ForgotPasswordModalContext.Provider>
  );
};
